module.exports = "<!-- <div class=\"sidebar-footer\"></div> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/app-sidebar-footer/app-sidebar-footer.component.html
// module id = ./src/app/shared/app-sidebar-footer/app-sidebar-footer.component.html
// module chunks = main